import * as React from "react";
import { UitkFigure } from "uitk-react-images";

import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";
import { cropResizeSrc } from "src/components/shared/BlossomImage/BlossomImage";
import { isVariantEnabled, Experiment } from "src/components/utility/experiment";

export interface HeroImageProps {
  src: string;
  alt: string;
  className?: string;
  context: ExtendedContextStore;
}

export const HeroImage: React.FC<HeroImageProps> = ({ context, src, alt, children, className = "" }) => {
  const isBrandRefreshJuneEnabled = isVariantEnabled(context, Experiment.EXPEDIA_BRAND_REFRESH_JUNE);
  const optimizeImg = isBrandRefreshJuneEnabled ? src : cropResizeSrc(src, { width: 1680, height: 485 }, "medium");

  return (
    <UitkFigure className={`bexHeroImageBackground ${className}`} src={optimizeImg}>
      {children}
    </UitkFigure>
  );
};
